// extracted by css-extract-rspack-plugin
export default {"container":"container-tITk4t","ai-fab-in":"ai-fab-in-tid3JD","aiFabIn":"ai-fab-in-tid3JD","fab":"fab-LII2nx"};